export const scoreReportDraftLink = (draftId: number) => `/scoreReport?draftId=${draftId}`;
export const scoreReportEssayLink = (essayId: number) => `/scoreReport?essayId=${essayId}`;
